module.exports = __webpack_public_path__ + "static/media/amazon.448f7c20.png";